export default function setMediaMetadata (title, poster) {
  try {
    if ('mediaSession' in navigator) {
      navigator.mediaSession.metadata = new window.MediaMetadata({
        title: title || '',
        artwork: poster ? [{ src: poster }] : []
      })
    }
  } catch (_) {
    // Do nothing
  }
}
